import { useMemo } from "react";
import { canScheduleBucketsInToken, getStoredAccessToken } from "@/utils/keycloakRoles";

/**
 * A operação Musa que agenda caçamba no Hub (`bucket_schedule`) pede movimentação de equipamento
 * com data passada, para formalizar o que foi combinado por fora da plataforma. O pedido segue o
 * caminho normal: o transportador confirma e registra com a data em que aconteceu.
 *
 * O memo é chaveado no token: o refresh troca a string e recalcula.
 */
export function useCanBackdateBucketRequests(): boolean {
  const token = getStoredAccessToken();
  return useMemo(() => (token ? canScheduleBucketsInToken() : false), [token]);
}
